import React from "react";
import "./SponsorSection.css";

const DEFAULT_GROUPS = [
  {
    label: "YACHT PARTNER",
    items: [
      {
        name: "Once Yachting",
        logoSrc: "/img/sponsor_logo/once-yachting.png",
        alt: "Once Yachting logo",
      },
    ],
  },
  {
    label: "TICKETING PARTNER",
    items: [
      {
        name: "Casheers",
        logoSrc: "/img/sponsor_logo/casheers.png",
        alt: "Casheers logo",
      },
    ],
  },
  {
    label: "PARTY PROMOTERS",
    items: [
      { name: "Oncloud9", logoSrc: "/img/sponsor_logo/onclound9.png", alt: "Oncloud9 logo" },
      { name: "djplus", logoSrc: "/img/sponsor_logo/djpluscir.png", alt: "djplus logo" },
      { name: "BPM", logoSrc: "/img/sponsor_logo/bpm.png", alt: "BPM logo" },
    ],
  },
  {
    label: "SPONSORS",
    items: [
      {
        name: "Assetwise",
        logoSrc: "/img/sponsor_logo/assetwise.png",
        alt: "Assetwise logo",
      },
      { name: "Chang", logoSrc: "/img/sponsor_logo/chang.jpg", alt: "Chang logo" },
      {
        name: "Hennessy Artistry",
        logoSrc: "/img/sponsor_logo/hennessy.jpg",
        alt: "Hennessy Artistry logo",
      },
      {
        name: "Moët & Chandon",
        logoSrc: "/img/sponsor_logo/moet.png",
        alt: "Moët and Chandon logo",
      },
    ],
  },
];

export function SponsorSection({ groups, className }) {
  const displayGroups = groups && groups.length > 0 ? groups : DEFAULT_GROUPS;
  const sectionClass = ["sponsor-section", className].filter(Boolean).join(" ");

  return (
    <section
      className={sectionClass}
      aria-label="Event sponsors"
      style={{ backgroundImage: "url(/img/bg-sponsor/bg.jpg)" }}
    >
      <div className="sponsor-section-overlay" aria-hidden />
      <div className="sponsor-section-content">
      {displayGroups.map((group) => {
        const firstFour = group.items.slice(0, 4);
        const rest = group.items.slice(4);
        return (
          <div className="sponsor-group" key={group.label}>
            <div className="sponsor-group-label">{group.label}</div>
            <div className="sponsor-logos">
              <div className="sponsor-logos-row sponsor-logos-row--primary">
                {firstFour.map((item) => (
                  <div className="sponsor-logo-wrapper" key={item.name}>
                    <img
                      src={item.logoSrc}
                      alt={item.alt || item.name}
                      className="sponsor-logo"
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
              {rest.length > 0 && (
                <div className="sponsor-logos-row">
                  {rest.map((item) => (
                    <div className="sponsor-logo-wrapper" key={item.name}>
                      <img
                        src={item.logoSrc}
                        alt={item.alt || item.name}
                        className="sponsor-logo"
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
      </div>
    </section>
  );
}

export default SponsorSection;
